export const colorPrimary = '#8B5CF6';
export const colorPrimaryLight = '#EDE9FE';
export const colorPrimaryMid = '#B8A9F8';
export const colorPrimaryHover = '#7C3AED';
export const colorDataWarm = '#CC6B00';
export const colorInk = '#332E4A';
export const colorMuted = '#614D4D';
export const colorFaint = '#A9A9A9';
export const colorBorder = '#DDD6FE';
export const colorBorderSoft = '#EDE9FE';
export const colorSurface = '#FFFFFF';
export const colorPageBg = '#F7F7FA';
export const colorTrack = '#F4F2FA';
export const colorInactive = '#D8D8DE';
export const colorGood = '#006400';
export const colorWarn = '#FFA500';
export const colorHarvest = '#FFA500';
export const colorBad = '#B91C1C';
export const colorNeutralCrop = '#7C7691';

// Dry-months-by-season stacked bars. Rabi reuses colorPrimary and Zaid
// reuses colorDataWarm; Kharif needs its own hue, distinct from both.
export const colorKharif = '#077BAB';

// One colour per supported crop type, for the cropping-history bars and legend.
export const CROP_COLORS = {
  Bajra: '#009395',
  Chilli: '#A50D1C',
  Corn: '#B86A0B',
  Cotton: '#B950B2',
  Gram: '#0052B7',
  Groundnut: '#086C00',
  Mustard: '#8B2186',
  Rice: '#2D9924',
  Sorghum: '#00696B',
  Soybeans: '#D74745',
  Sugarcane: '#814802',
  Wheat: '#317DE9',
};

// Unknown or unmapped crop (e.g. UNKNOWN_CROP from the API).
export const CROP_FALLBACK = '#6B6B76';
